import { render, staticRenderFns } from "./residence.vue?vue&type=template&id=b95c6230&scoped=true&"
import script from "./residence.vue?vue&type=script&lang=js&"
export * from "./residence.vue?vue&type=script&lang=js&"
import style0 from "./residence.vue?vue&type=style&index=0&id=b95c6230&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b95c6230",
  null
  
)

export default component.exports